/**
 * Transforma um número telefônico representado no formato ITU-T E.164 em uma estrutura de dados composta por
 * um código telefônico internacional e o restante do número em separado. A implementação foi realizada com
 * base na tabela de codificação encontrada em:
 * 
 * https://en.wikipedia.org/wiki/List_of_country_calling_codes
 */

angular.module("avlib").filter("avE164", function() {
	
	return function(input) {
		/*
		 * Verificando se o valor fornecido segue o padrão esperado +9999999:
		 */
		if (!/\+(\d+)/.test(input)){
			return null;
		}
		/*
		 * Neste mapa, o primeiro dígito do número telefônico funciona como chave.
		 * A cada chave está associado um array contendo números de dois dígitos.
		 * Este números são os códigos internacionais de dois dígitos associados
		 * a chave informada. Se os dois primeiros dígitos de um certo número telefônico
		 * não podem ser encontrados no array correspondente, então trata-se de um
		 * número com código internacional de 3 dígitos. Tomando como exemplo o número
		 * brasileiro 5521999999999. Ele começa com 5, então acessamos o mapa utilizando
		 * 5 como chave. Aí descobrimos que 55 está presente no array correspondente,
		 * logo, trata-se de um código internacional de dois dígitos, no caso 55.
		 * Agora o número da Albânia 35549999999. Ele começa com 3. Acessando o mapa
		 * verificamos que 35 não consta no array correspondente. Então o número possui
		 * código internacional de 3 dígitos, ou seja 355. 
		 */
		var prefixMap = {
			2: [20, 27, 28],
			3: [30, 31, 32, 33, 34, 36, 39],
			4: [40, 41, 43, 44, 45, 46, 47, 48, 49],
			5: [51, 52, 53, 54, 55, 56, 57, 58],
			6: [60, 61, 62, 63, 64, 65, 66],
			8: [81, 82, 83, 84, 86, 89],
			9: [90, 91, 92, 93, 94, 95, 98],
		};
		/*
		 * Verificando se o argumento informado tem condições mínimas de ser processado:
		 */
		if (input.startsWith('+') && input.length > 3){
			/*
			 * Obtendo o primeiro dígito, que será a chave para o mapa de códigos telefônicos:
			 */
			var firstDigit = input.charAt(1);
			/*
			 * Se o primeiro dígito é 1 ou 7, trata-se de números dos EUA ou da Rússia, que
			 * possuem códigos telefônicos de 1 único dígito:
			 */
			if (firstDigit == 1 || firstDigit == 7){
				return {countryCode: firstDigit, phoneNumber: input.substr(2)}
			}else{
				/*
				 * Caso contrário, vamos verificar se os dois primeiros dígitos do número
				 * estão registrados no array de códigos internacionais de dois dígitos
				 * correspondente:
				 */
				var twoDigitCodes = prefixMap[firstDigit];
				/*
				 * Primeiro verificando se o primeiro dígito leva a um código de dois dígitos válido.
				 */
				if (twoDigitCodes){
					var twoDigits = input.substr(1,2); 
					var index = twoDigitCodes.findIndex(function(code){
						return code == twoDigits;
					});
					if (index > -1){
						/*
						 * Se o código de dois dígitos foi encontrado no array, então consideraremos
						 * os dois primeiros dígitos código e separaremos do restante:
						 */
						return {countryCode: twoDigits, phoneNumber: input.substr(3)}
					}else{
						/*
						 * Se o código de dois dígitos não foi encontrado no array, então consideraremos
						 * os três primeiros dígitos código e separaremos do restante:
						 */
						return {countryCode: input.substr(1,3), phoneNumber: input.substr(4)}
					}
				}else{
					return null;
				}
			}
		}
		return null;
	};
});
